import * as React from "react";
import styled from "@emotion/styled";
import { Colors } from "../../Themes";

interface IProps {
  children: React.ReactNode;
}

const CardWrapper = styled.div`
  width: 520px;
  height: 610px;
  background: ${Colors.snow};
  padding: 3rem;
  border-radius: 3px;
  box-shadow: 0 7px 14px 0 rgba(59, 65, 94, 0.1),
    0 3px 6px 0 rgba(0, 0, 0, 0.07);
`;

export default class SignUpWrapper extends React.Component<IProps> {
  render() {
    return <CardWrapper>{this.props.children}</CardWrapper>;
  }
}



// WEBPACK FOOTER //
// ./src/Components/Layouts/SignUpWrapper.tsx